import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/source-serif-4/600.css';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { estPageInscription, PageInscription } from './ecrans/Inscription';
import { retirerJeton } from './domaine/inscription';
import { creerIdentite, lireConfiguration } from './auth/identite';
import { purgerAnciensComplements } from './domaine/complementsLocaux';
import { PageConfirmationContact, PageEstimation } from './ecrans/Estimation';

const racine = createRoot(document.getElementById('racine') as HTMLElement);
// O42 : les versions précédentes gardaient des compléments de décision dans localStorage ; on les efface.
purgerAnciensComplements();

// Pages publiques de l'outil gratuit d'estimation : sans connexion, sans configuration ni fournisseur d'identité.
// #/estimation/contact?jeton=… : confirmation d'une demande de contact (lien reçu par courriel).
if (estPageInscription(new URL(window.location.href))) {
  const jeton = retirerJeton(new URL(window.location.href), adresse => window.history.replaceState(null, '', adresse));
  racine.render(<StrictMode><PageInscription jeton={jeton} /></StrictMode>);
} else if (/^#\/estimation\/contact(\?|$)/.test(window.location.hash)) {
  racine.render(
    <StrictMode>
      <PageConfirmationContact />
    </StrictMode>,
  );
} else if (/^#\/estimation(\?|$)/.test(window.location.hash)) {
  racine.render(
    <StrictMode>
      <PageEstimation />
    </StrictMode>,
  );
} else {
  demarrerApplication();
}

function demarrerApplication(): void {
  lireConfiguration()
    .then(async (config) => {
      const identite = await creerIdentite(import.meta.env as unknown as Record<string, string | undefined>, config);
      // Retour du fournisseur d'identité (mode OIDC) : échange du code, puis URL nettoyée (le code et l'état ne
      // restent ni dans l'historique ni dans la barre d'adresse) et retour à l'écran d'avant la connexion.
      const url = new URL(window.location.href);
      let retour = false;
      try {
        retour = await identite.traiterRetour(url);
      } finally {
        if (retour || url.searchParams.has('code') || url.searchParams.has('error')) {
          window.history.replaceState(null, '', `${url.pathname}${retour ? (identite.ecranApresRetour ?? url.hash) : ''}`);
        }
      }
      racine.render(
        <StrictMode>
          <App identite={identite} carteSouhaitee={config.carte} demonstration={config.demonstration === true} />
        </StrictMode>,
      );
    })
    .catch((e: unknown) => {
      racine.render(
        <main style={{ padding: 24 }}>
          <p role="alert">Démarrage impossible : {e instanceof Error ? e.message : String(e)}</p>
          <p>
            <a href="/">Recommencer</a>
          </p>
        </main>,
      );
    });
}
